function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManreadingPana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.31,40.94,216,129.55A4.7,4.7,0,0,1,211.9,135l-67,8.48L129.57,53.33l64.36-16.49A5.17,5.17,0,0,1,200.31,40.94Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.23,135.16l-.32,0-67.12,8.49,0-.15L129.38,53.21l64.51-16.53a5.34,5.34,0,0,1,6.58,4.24l15.69,88.6a4.87,4.87,0,0,1-3.93,5.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.62 36.98 198.12 38.05 214.22 128.97 214.56 130.85 207.95 132.01 191.62 36.98",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.27,53.19s22-13.31,62.23-16.55l16.43,95.51L144.29,142Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.27,53.19s0,.14.07.42.12.69.22,1.24c.18,1.09.46,2.71.82,4.82l3.1,18.2c2.65,15.62,6.42,37.82,10.89,64.12l-.09-.06,63.64-9.87-.07.1c-.2-1.13-.41-2.35-.62-3.57-5.93-34.52-11.41-66.41-15.79-91.94l.07.06a199.25,199.25,0,0,0-26.46,3.89,165.84,165.84,0,0,0-19.65,5.54,120.23,120.23,0,0,0-12.07,4.94l-1.77.88-1.27.66-1,.57.25-.16.76-.43,1.27-.67,1.77-.89a118.64,118.64,0,0,1,12.05-5A165.38,165.38,0,0,1,165,40.49a198.87,198.87,0,0,1,26.47-3.92h.06v.06C196,62.15,201.45,94,207.4,128.56c.21,1.22.42,2.44.61,3.57l0,.09h-.09l-63.64,9.85h-.07V142c-4.44-26.33-8.19-48.54-10.82-64.17-1.32-7.81-2.35-14-3.06-18.2-.35-2.1-.62-3.72-.81-4.81-.08-.54-.15-1-.2-1.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,52.44c1.43,6.76,5.92,31.4,5.92,31.4L140.53,78l4.39,3.76-6.75-34.2L133.22,50A2.24,2.24,0,0,0,132,52.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.89,131.68s0-.08,0-.24l-.14-.72c-.11-.63-.28-1.55-.49-2.74-.43-2.39-1-5.84-1.79-10.1-1.48-8.54-3.47-20.34-5.64-33.38s-4.16-24.84-5.59-33.38L194.46,41c-.2-1.19-.36-2.12-.46-2.75-.06-.31-.09-.55-.12-.72s0-.24,0-.24l.06.24c0,.16.07.4.13.71.11.63.28,1.56.5,2.74.42,2.4,1,5.85,1.78,10.11,1.48,8.53,3.47,20.33,5.64,33.38s4.16,24.83,5.59,33.38L209.27,128c.2,1.19.36,2.11.47,2.75,0,.31.09.55.12.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.63,131.37s-3.73-21-8.23-46.86-8.11-46.88-8.07-46.89,3.73,21,8.23,46.86S211.67,131.36,211.63,131.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.24,64l16.25,91.72a3.07,3.07,0,0,0,3.8,2.31l68.63-14.46c1.65-.38.05-3.22-.22-4.76L111,56.73a3,3,0,0,0-3.47-2.36L59,60.48A3.07,3.07,0,0,0,56.24,64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.02 59.17 83.85 155.33 144.69 142.13 129.57 53.33 66.02 59.17",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.27,56.63s35.84-13.42,58.22-2.6l15.12,88.8L88.55,154.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.35,55.93c.12.7,7.2,40.48,17.36,97.54l-.09-.06,52.81-10.71,3.24-.65-.06.09c-5.72-33.6-11-64.46-15.11-88.8l0,0c-1-.45-2-1-3.11-1.3l-.78-.29a7.13,7.13,0,0,0-.78-.26l-1.56-.47a47.67,47.67,0,0,0-6.21-1.29c-2-.31-4-.44-6-.55-1,0-1.93-.06-2.87-.06h-1.4c-.46,0-.92,0-1.38,0a97.18,97.18,0,0,0-10.14.89c-3.1.44-5.92,1-8.45,1.5-5.06,1.08-8.94,2.2-11.56,3-1.31.41-2.31.73-3,1l-1,.35,1-.37c.67-.23,1.66-.57,3-1,2.61-.82,6.49-1.95,11.55-3C89.4,51,92.22,50.46,95.33,50a99.68,99.68,0,0,1,10.15-.91q.67,0,1.38,0l1.4,0c.94,0,1.9,0,2.87.06,2,.11,4,.24,6,.55a47.69,47.69,0,0,1,6.22,1.27l1.57.48a6.48,6.48,0,0,1,.78.26l.79.29c1.06.35,2.07.85,3.12,1.3h0v0l15.14,88.8v.07l-.07,0-3.24.66L88.65,153.56l-.08,0v-.08C78.49,96.42,71.47,56.63,71.35,55.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.8 63.4 66.02 59.17 83.85 155.33 75.01 154.93 58.8 63.4",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.83,152.64s-3.66-20.17-8.07-45.08-8-45.11-7.91-45.12,3.66,20.18,8.07,45.09S76.87,152.64,76.83,152.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.38 75.83 61.28 92.41 70.01 101.95 65.38 75.83",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.83,151.75s-3.49-19.24-7.7-43-7.58-43-7.53-43,3.49,19.23,7.7,43S78.88,151.74,78.83,151.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.46,154.76s-3.68-20.32-8.12-45.4-8-45.41-8-45.42,3.69,20.31,8.13,45.4S81.51,154.75,81.46,154.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.79,64.22a7.85,7.85,0,0,1-1.5-.15c-1-.14-2.36-.31-4.08-.47a76.72,76.72,0,0,0-26.82,2.21c-1.67.44-3,.84-3.94,1.13a7.19,7.19,0,0,1-1.46.39,8.53,8.53,0,0,1,1.39-.58c.91-.36,2.25-.8,3.92-1.29a68.14,68.14,0,0,1,27-2.22c1.73.21,3.12.43,4.07.63A7.68,7.68,0,0,1,121.79,64.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,71.88a9.2,9.2,0,0,1-1.51-.15c-1-.14-2.35-.31-4.07-.47a76.72,76.72,0,0,0-26.82,2.21c-1.67.44-3,.83-3.94,1.13a7.19,7.19,0,0,1-1.46.39,8.53,8.53,0,0,1,1.39-.58c.91-.36,2.24-.8,3.91-1.29a68.21,68.21,0,0,1,27-2.22c1.72.21,3.12.43,4.07.63A8,8,0,0,1,123,71.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.29,79.54a9.12,9.12,0,0,1-1.51-.15c-1-.14-2.35-.31-4.07-.47a76.72,76.72,0,0,0-26.82,2.21c-1.67.44-3,.83-4,1.13a8,8,0,0,1-1.45.39,8,8,0,0,1,1.39-.58c.91-.36,2.24-.8,3.91-1.29a68.18,68.18,0,0,1,26.95-2.22c1.73.2,3.12.43,4.08.63A8,8,0,0,1,124.29,79.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.53,87.2a9.14,9.14,0,0,1-1.5-.15c-1-.14-2.35-.31-4.08-.47a76.69,76.69,0,0,0-26.81,2.21c-1.68.44-3,.83-4,1.13a7.71,7.71,0,0,1-1.46.39,9,9,0,0,1,1.4-.58c.9-.36,2.24-.8,3.91-1.29A68.11,68.11,0,0,1,106.41,86a69.23,69.23,0,0,1,13.58.23c1.73.21,3.12.44,4.07.64A7.41,7.41,0,0,1,125.53,87.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.45,95a8.58,8.58,0,0,1-1.5-.16c-1-.13-2.36-.3-4.08-.46a79.07,79.07,0,0,0-13.5-.09,78.11,78.11,0,0,0-13.31,2.3c-1.68.44-3,.83-4,1.13a9.45,9.45,0,0,1-1.46.39A9.63,9.63,0,0,1,91,97.51c.91-.35,2.25-.8,3.92-1.29a68.63,68.63,0,0,1,27-2.22c1.73.21,3.12.43,4.07.63A8.07,8.07,0,0,1,127.45,95Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.76,104.8a11.12,11.12,0,0,1-1.58-.16c-.5-.08-1.12-.16-1.84-.23s-1.53-.18-2.44-.24c-1.81-.17-4-.25-6.38-.29s-5,.08-7.81.3-5.39.59-7.76,1-4.49.87-6.24,1.34c-.89.21-1.68.44-2.37.63s-1.3.37-1.78.53a8,8,0,0,1-1.54.41,9.7,9.7,0,0,1,1.47-.61c.48-.18,1.07-.39,1.76-.61s1.48-.48,2.36-.71c1.76-.51,3.88-1,6.26-1.45s5-.79,7.79-1,5.45-.29,7.86-.26,4.6.19,6.41.41c.91.08,1.73.21,2.45.31s1.33.21,1.83.32A8.64,8.64,0,0,1,130.76,104.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.52,114a8.65,8.65,0,0,1-1.59-.07c-1-.09-2.5-.16-4.33-.22a95.06,95.06,0,0,0-14.26.76c-5.54.7-10.51,1.7-14.11,2.43l-4.26.85a8,8,0,0,1-1.57.25,10.6,10.6,0,0,1,1.53-.45c1-.25,2.44-.6,4.23-1A142.15,142.15,0,0,1,112.27,114a81.36,81.36,0,0,1,14.34-.62c1.84.11,3.32.24,4.34.39A8.52,8.52,0,0,1,132.52,114Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,123.93a8.78,8.78,0,0,1-1.57,0c-1,0-2.48,0-4.28.09a116,116,0,0,0-14,1.45c-5.44.88-10.31,2-13.8,3-1.75.47-3.16.86-4.13,1.14a8.28,8.28,0,0,1-1.53.38,9,9,0,0,1,1.47-.57c1-.35,2.35-.79,4.09-1.3A115.32,115.32,0,0,1,113,125a95.18,95.18,0,0,1,14.11-1.31c1.81,0,3.28,0,4.29.08A8.41,8.41,0,0,1,133,123.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.65,50.59a10.66,10.66,0,0,1-1.77.29c-1.15.15-2.8.39-4.84.7-4.08.63-9.68,1.67-15.78,3.24s-11.5,3.4-15.36,4.84c-1.94.71-3.5,1.31-4.57,1.74a13.75,13.75,0,0,1-1.69.61s.13-.1.41-.23l1.2-.57c1.05-.48,2.59-1.13,4.51-1.9a136.61,136.61,0,0,1,15.37-5A134.11,134.11,0,0,1,175,51.22c2-.27,3.71-.45,4.87-.54l1.33-.09A1.35,1.35,0,0,1,181.65,50.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.38,66.69a1.4,1.4,0,0,1-.47.13l-1.37.27-5,.94c-4.24.81-10.08,2-16.47,3.61s-12.12,3.27-16.25,4.54l-4.88,1.53-1.33.41a1.69,1.69,0,0,1-.48.1,2.46,2.46,0,0,1,.44-.2l1.3-.5c1.13-.43,2.79-1,4.84-1.69,4.1-1.37,9.82-3.1,16.23-4.7s12.27-2.75,16.54-3.46c2.13-.36,3.86-.63,5.06-.78l1.38-.17A3,3,0,0,1,187.38,66.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.34,75.63a1.41,1.41,0,0,1-.47.14l-1.39.28-5.12,1c-4.31.83-10.27,2-16.81,3.46s-12.45,2.89-16.71,4l-5.05,1.27-1.38.33a2.11,2.11,0,0,1-.49.08,2,2,0,0,1,.47-.19l1.35-.42c1.17-.36,2.89-.85,5-1.43,4.24-1.16,10.13-2.66,16.69-4.12S177,77.4,181.3,76.67c2.17-.37,3.93-.65,5.14-.82l1.41-.19A2,2,0,0,1,188.34,75.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.49,85.58c0,.14-10.64,2.35-23.81,4.93s-23.89,4.55-23.92,4.41,10.63-2.35,23.82-4.92S190.46,85.44,190.49,85.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.57,95.35c0,.14-10.63,2.25-23.79,4.71s-23.86,4.35-23.89,4.21,10.63-2.26,23.79-4.72S193.54,95.21,193.57,95.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.51,106c0,.14-10.68,1.91-23.91,3.94s-24,3.57-24,3.43,10.68-1.91,23.91-3.94S195.49,105.84,195.51,106Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8,116.44c0,.15-9.42,1.79-21.1,3.67s-21.16,3.29-21.18,3.15,9.42-1.78,21.1-3.67S194.78,116.3,194.8,116.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.81,58.76a1.87,1.87,0,0,1-.46.11L184,59.1l-4.9.82c-4.14.72-9.83,1.85-16,3.44s-11.73,3.35-15.7,4.71l-4.7,1.65-1.27.44a1.4,1.4,0,0,1-.46.12,1.7,1.7,0,0,1,.42-.22l1.24-.53c1.09-.46,2.67-1.08,4.65-1.8A163.74,163.74,0,0,1,163,62.86c6.22-1.6,11.94-2.67,16.1-3.3,2.08-.32,3.76-.54,4.93-.66l1.35-.13A1.38,1.38,0,0,1,185.81,58.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.9,
    y: 35.66,
    width: 105.32,
    height: 174.33,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.4,
    y: 35.66,
    width: 105.32,
    height: 174.33,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.89,
    y: 39.19,
    width: 96.35,
    height: 167.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.23,
    y: 60.93,
    width: 59.25,
    height: 123.79,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.23,140.92c-.14-11.57,10.26-22.86,21.71-24.47,5.46-.77,11.26.31,16.37-1.78,9.1-3.73,12-15.83,21.17-19.42l.42,89.47H371.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,326.14a42.41,42.41,0,0,0-18.18-6.26c-3-.31-6.21-.22-8.59,1.58a1.77,1.77,0,0,0-.89,1.57,1.88,1.88,0,0,0,.84,1.07c7.4,5.65,18.58,6.36,26.82,2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.53,325.62A88,88,0,0,1,40.8,315.29a29.75,29.75,0,0,1-7.37-13.61c-.31-1.55-.41-3.32.59-4.56,9.35,7.31,16.71,16.77,18.51,28.5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9,326.06a42.67,42.67,0,0,1,.22-15.41c1.18-5,3.91-9.85,8.21-12.72,1.62,3.78.92,8.14-.22,12.09A58.83,58.83,0,0,1,53,327.16",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.08,342.5c-5.57.68-10.42,3.61-14.58,7.38a27.63,27.63,0,0,0-8.34,14.31c5.47-.33,10.1-4.19,13.46-8.51s5.69-9.05,9.38-13.09",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.07,345.13a36,36,0,0,1,4.15-34c3.17,11.29,2,24-4.15,34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.19,359.56a26,26,0,0,0-24.86,14.31c-.3.62-.58,1.4-.16,1.95a1.83,1.83,0,0,0,1.64.49c4.9-.32,9.25-3.27,12.83-6.62s6.7-7.24,10.66-10.14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8,358.78a46.42,46.42,0,0,1-.46-25.86c.91-3.33,2.44-6.84,5.52-8.4a.85.85,0,0,1,1.38.47,15.69,15.69,0,0,1,1.3,7.42,46.53,46.53,0,0,1-1.16,7.51c-1,4.59-1.49,9.53-4,13.49a27.28,27.28,0,0,0-1.61,3c-.47,1-.48,1.36-.91,2.16",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.89,363.56c-2.38-9,.15-20,5.84-27.42.42-.54,1-1.13,1.66-1.06,1,.09,1.33,1.49,1.28,2.54a49.58,49.58,0,0,1-8.78,25.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.78,365.54c11,2.85,23.59.08,32.73-6.66a26.5,26.5,0,0,0-17.72-2.17c-5.92,1.35-11.32,4-15,8.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.22,359.52c6.15-10,17.95-16.58,29.7-17.18-1.35,4.78-5.28,8.5-9.71,10.74s-9.38,3.22-14.26,4.17c-1.9.37-4.5.77-5.73,2.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.5,330.3c1.67-5.71,3.34-11.46,3.8-17.39s-.39-12.12-3.47-17.21c-5.74,11.12-6.32,24.12-.5,35.2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.85,320.52c6.72-12.21,20.43-22,34.31-23.34-5.36,13.33-19.95,23.63-34.31,23.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.62,322.92c10,1.52,18.56,7.92,27.93,11.8a12.41,12.41,0,0,0,6.31,1.21,4.94,4.94,0,0,0,3.1-8.74,13.36,13.36,0,0,0-4.59-2.78c-10.2-4.25-21.14-4.36-31.89-1.78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.82,330c2.27.65,3.05,1.82,4.84,3.35a52.28,52.28,0,0,0,21.18,10.88c.81.2,1.87.28,2.27-.45s-.09-1.41-.54-2a29.26,29.26,0,0,0-12.79-8.68c-4.89-1.82-9.12-4-15-3.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,287.49A40.1,40.1,0,0,0,142,297.94a2.11,2.11,0,0,0,1.39-.5c.78-.84-.15-2.14-1.05-2.84-9-7.05-20-10-31.07-7.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,284.65a42.8,42.8,0,0,1,38.34-6.33c-4.83,4.76-11.53,7.32-18.27,8A57.84,57.84,0,0,1,119,284.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,265.14c-.89-9-.31-16.14-.94-25.2-.05-.72-.2-1.59-.88-1.85-.94-.37-1.73.79-2,1.75a28.92,28.92,0,0,0,3.85,25.1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.3,266.13c6.11-3.78,10.7-8.71,14.94-14.52,2.95-4,5.44-8.87,4.77-13.82-4.15-.09-8.08,2.2-10.78,5.35a30.18,30.18,0,0,0-5.49,11.05c-1.2,4-2,8-3.44,11.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,262.06a120.38,120.38,0,0,0,36.76-21.68c-4.39-1.77-9.42-.71-13.81,1.06-10,4.05-18.22,10.88-23.14,20.52",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.43,271.07c6.79.74,13.68,1.22,20.41.1s12.87-3.73,19.06-6.34a2.19,2.19,0,0,0,1.29-1,1.48,1.48,0,0,0-.46-1.63,4,4,0,0,0-1.63-.76c-6.72-1.88-14-1-20.59,1.23a95.36,95.36,0,0,0-18.08,8.38",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.68,287.8c-4.63-9.35-4.33-20.26-.33-29.89,2.82,4.29,3.16,9.75,2.64,14.86s-2.06,10.36-2.16,15.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.18,278.47a41.67,41.67,0,0,0-31,13.19c5.77.91,11.71-.58,17-3.14s9.91-6.16,14.54-9.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.75,274.31c-5.66-.46-11.1-1.16-16.53.51s-10.39,5.44-12.61,10.68a29.79,29.79,0,0,0,15.5-2.93,89.08,89.08,0,0,0,13.64-8.26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.16,274.5c-5.09-3.34-10.31-6.73-16.23-8.11S39.14,266,35,270.49c4.79,2.82,10.61,3.15,16.17,3.15s12.37-.07,17.62,1.78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.19,274.77c-8.7-8.54-12-23.89-8.49-35.56a54.23,54.23,0,0,1,8.49,35.56",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.11,250.57c1.64-3.81,2.79-7.82,4.26-11.7a33.57,33.57,0,0,1,6.08-10.78,16,16,0,0,1,10.77-5.58,43.36,43.36,0,0,1-20.9,28.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.78,255.61c-2.72-3.73-5.85-8.81-9.53-11.6s-8.48-4.47-13-3.4a30.2,30.2,0,0,0,22.5,15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,250.88c-1.77-4.52-3.57-9.09-4.29-13.89s-.28-9.94,2.18-14.13c4.77,9,6.31,18.71,2.36,28.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.15,222.86c2.7-9,10.9-15.54,19.74-18.56a7.38,7.38,0,0,1,3.46-.52,3,3,0,0,1,2.55,2.13c.32,1.52-.93,2.89-2.12,3.9a67.11,67.11,0,0,1-23.63,13.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.25,215.54c.34-5.77.7-11.62,2.58-17.08s5.49-10.6,10.75-13c.89,5.83-1.68,11.62-4.78,16.64s-6.83,9.74-8.69,15.33",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.11,219.51c-2.24-6.52-2.47-14.8-6.37-20.48-2.73-4-7.1-6.68-9.46-10.88a16.58,16.58,0,0,0,.55,12.35,35.79,35.79,0,0,0,7.23,10.34c2.89,3.09,5.36,5.41,8,8.67",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.15,411.52c-.17,0-.32-43.5-.34-97.14s.12-97.14.3-97.14.32,43.48.33,97.14S92.32,411.52,92.15,411.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.16,281.23a9.57,9.57,0,0,1-1.64.62l-4.5,1.51c-3.79,1.3-9,3.17-14.66,5.49s-10.89,4.35-13.9,7a10.35,10.35,0,0,0-2.79,3.69c-.43,1-.51,1.65-.56,1.64s0-.16,0-.46a7.48,7.48,0,0,1,.32-1.27,9.82,9.82,0,0,1,2.73-3.93,24.47,24.47,0,0,1,6-3.75c2.41-1.12,5.08-2.3,7.92-3.46,5.67-2.33,10.93-4.14,14.77-5.33,1.91-.6,3.48-1,4.56-1.33A10.09,10.09,0,0,1,130.16,281.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.62,250.63a3.34,3.34,0,0,1-.46.49l-1.4,1.31-5.21,4.73L118.21,272.6c-6.77,6-12.62,11.79-16.67,16.12-2,2.17-3.63,4-4.72,5.21l-1.26,1.44a3,3,0,0,1-.47.48,2.49,2.49,0,0,1,.37-.56c.26-.35.65-.87,1.17-1.51,1-1.31,2.59-3.15,4.58-5.36a219.29,219.29,0,0,1,16.58-16.28c6.8-6,13-11.42,17.47-15.31l5.34-4.58,1.47-1.23C142.42,250.75,142.6,250.61,142.62,250.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.9,278.73c-.17-.08,1.24-3.34,2.65-7.47s2.09-7.62,2.27-7.59-.24,3.61-1.68,7.79a50.64,50.64,0,0,1-2.1,5.23A7.93,7.93,0,0,1,110.9,278.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.19,305.06a7.59,7.59,0,0,1-1-1.21l-2.68-3.43c-2.24-2.9-5.34-6.91-8.82-11.29s-6.68-8.32-9-11.16c-1.09-1.35-2-2.49-2.73-3.38A8.25,8.25,0,0,1,67,273.3a7.7,7.7,0,0,1,1.13,1.13c.7.76,1.68,1.87,2.88,3.25,2.41,2.78,5.67,6.67,9.15,11.06s6.53,8.44,8.69,11.41c1.08,1.49,1.94,2.7,2.51,3.55A8,8,0,0,1,92.19,305.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.86,294.36c-.11.11-2.33-2.53-3.5-6.54a18.78,18.78,0,0,1-.79-6.59l.28,0c-.12.51-.22.77-.26.77s-.06-.29,0-.81l.28,0A29.72,29.72,0,0,0,81,287.64C82.09,291.53,84,294.25,83.86,294.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1,280.82a11.56,11.56,0,0,0-2.44-1.41,16.32,16.32,0,0,0-6.77-.54,42.3,42.3,0,0,0-6.81,1.1,19.34,19.34,0,0,1-2.81.67,9.78,9.78,0,0,1,2.69-1.1,30.89,30.89,0,0,1,6.88-1.3,14.85,14.85,0,0,1,7,.76A4.39,4.39,0,0,1,73.1,280.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.55,277.54c0,.1-1.42-.56-3.74-1.36a38.79,38.79,0,0,0-9.32-1.91,38.21,38.21,0,0,0-9.5.48c-2.41.43-3.86.88-3.9.78a3.63,3.63,0,0,1,1-.42,23.2,23.2,0,0,1,2.82-.8,33.58,33.58,0,0,1,9.64-.67A32.89,32.89,0,0,1,67,275.77,21.46,21.46,0,0,1,69.63,277,4.18,4.18,0,0,1,70.55,277.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.11,263.67c-.17.05-1.39-4.19-2.73-9.46s-2.28-9.57-2.11-9.61,1.39,4.19,2.72,9.46S92.27,263.63,92.11,263.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.28,263.67c-.19.06-1-2.77-3-5.66a25.22,25.22,0,0,0-4.44-4.59,4.36,4.36,0,0,1,1.71.89,13.83,13.83,0,0,1,3.25,3.34C91.9,260.66,92.43,263.66,92.28,263.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.15,388.33c-.07,0-.2-1-.69-2.89a40.54,40.54,0,0,0-2.9-7.53c-3-6.14-8.48-13.93-15.42-21.73-3.45-3.93-6.79-7.64-9.62-11.19a78.4,78.4,0,0,1-6.88-9.92,48,48,0,0,1-3.47-7.36c-.32-.91-.55-1.62-.68-2.11a3.47,3.47,0,0,1-.18-.75s.37,1,1.09,2.77A53.28,53.28,0,0,0,57,334.84,83.21,83.21,0,0,0,64,344.62c2.85,3.52,6.19,7.21,9.64,11.15,7,7.82,12.42,15.7,15.35,22a37.17,37.17,0,0,1,2.74,7.66c.2.94.34,1.68.39,2.18A3.73,3.73,0,0,1,92.15,388.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5,349.54a17.42,17.42,0,0,1-1.8,1,38.45,38.45,0,0,0-4.67,3.09,52.12,52.12,0,0,0-6.13,5.59c-2.16,2.27-4.37,4.91-6.64,7.74-4.52,5.68-8.75,10.7-11.29,14.71-1.28,2-2.22,3.66-2.83,4.84a15.43,15.43,0,0,1-1,1.81,1.79,1.79,0,0,1,.17-.51c.13-.32.31-.81.6-1.41a46.92,46.92,0,0,1,2.68-5c2.46-4.1,6.66-9.2,11.17-14.86,2.27-2.84,4.51-5.48,6.71-7.75a49.44,49.44,0,0,1,6.28-5.55,32.85,32.85,0,0,1,4.82-2.95c.6-.3,1.09-.48,1.41-.62A1.7,1.7,0,0,1,126.5,349.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.17,362.12a24.86,24.86,0,0,1-3.81.56,50.14,50.14,0,0,0-9,1.77,27.08,27.08,0,0,0-8.08,4.24c-1.86,1.44-2.74,2.63-2.83,2.56a3.15,3.15,0,0,1,.57-.87,13.34,13.34,0,0,1,2-2,24.3,24.3,0,0,1,8.17-4.49,41.11,41.11,0,0,1,9.17-1.63A21.4,21.4,0,0,1,127.17,362.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.54,369.87c-.19-.11,1.52-2.73,2.85-6.25s1.54-6.68,1.76-6.64a5.73,5.73,0,0,1-.06,2,22,22,0,0,1-1.11,4.81,22.74,22.74,0,0,1-2.21,4.41A6.05,6.05,0,0,1,104.54,369.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.62,315.75a2.71,2.71,0,0,1-.61.32l-1.79.82c-.78.33-1.73.76-2.8,1.32s-2.33,1.13-3.64,1.91l-2.07,1.18c-.72.42-1.43.91-2.19,1.38-1.53.93-3.07,2.08-4.7,3.24a80.74,80.74,0,0,0-18.1,18.73c-1.11,1.67-2.2,3.25-3.08,4.81-.44.77-.91,1.5-1.3,2.23s-.75,1.44-1.11,2.12c-.74,1.33-1.27,2.6-1.78,3.7s-.92,2.05-1.23,2.84-.56,1.34-.75,1.82a3.1,3.1,0,0,1-.31.62,3,3,0,0,1,.19-.66l.64-1.86a29.85,29.85,0,0,1,1.14-2.91c.48-1.11,1-2.4,1.7-3.75.35-.69.71-1.4,1.08-2.15s.84-1.48,1.28-2.27c.87-1.58,2-3.17,3-4.87a77.78,77.78,0,0,1,18.23-18.86c1.66-1.17,3.22-2.3,4.77-3.22.77-.46,1.49-.95,2.22-1.35l2.11-1.16c1.33-.76,2.6-1.31,3.7-1.83a30.68,30.68,0,0,1,2.86-1.24L137,316A2.75,2.75,0,0,1,137.62,315.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.44,334a4.27,4.27,0,0,1,1.49-2.22,9.4,9.4,0,0,1,6-2.31,16.32,16.32,0,0,1,6.34,1.24,9.1,9.1,0,0,1,2.4,1.16,14.83,14.83,0,0,1-2.54-.74,18.91,18.91,0,0,0-6.18-1,9.83,9.83,0,0,0-5.75,2A18.62,18.62,0,0,0,110.44,334Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.37,338.16c-.17-.1,1.36-2.35,1.71-5.57s-.57-5.75-.38-5.81a3.84,3.84,0,0,1,.71,1.62,11.63,11.63,0,0,1,.3,4.26,11.27,11.27,0,0,1-1.28,4.08C106.9,337.7,106.43,338.2,106.37,338.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.11,394.56c.94,16.63,6,33.53,13.65,50.62h33.5c7.35-16.92,12-33.8,12.84-50.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.67,421.46c0,.17-11,.32-24.63.32s-24.64-.15-24.64-.32,11-.31,24.64-.31S116.67,421.29,116.67,421.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.92,427.48c0,.18-10.34.32-23.09.32s-23.1-.14-23.1-.32,10.34-.31,23.1-.31S115.92,427.31,115.92,427.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3,405.48c.17,0,.32,3.45.32,7.71s-.15,7.72-.32,7.72-.31-3.45-.31-7.72S76.13,405.48,76.3,405.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.25,405.48c.18,0,.32,3.58.32,8s-.14,8-.32,8-.31-3.58-.31-8S94.08,405.48,94.25,405.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1,405.34c.18,0,.32,3.65.32,8.15s-.14,8.15-.32,8.15-.31-3.64-.31-8.15S110.93,405.34,111.1,405.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,405.48c0,.17-12.94.31-28.9.31s-28.89-.14-28.89-.31,12.93-.32,28.89-.32S121,405.3,121,405.48Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.13,445.47c0,.14-96.77.26-216.12.26s-216.14-.12-216.14-.26,96.75-.26,216.14-.26S466.13,445.33,466.13,445.47Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.6,191.48a5.1,5.1,0,0,0-4.87,2.08,8.11,8.11,0,0,0-1.16,4.94,7.78,7.78,0,0,0,1.34,4.62,8.62,8.62,0,0,0,5.61,3,12.72,12.72,0,0,0,6.05-.76c.48-2,0-4.52-.48-6.67a10.64,10.64,0,0,0-2-4.5A7.35,7.35,0,0,0,371.6,191.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.86,186.8a4.57,4.57,0,0,1-.2.69c-.16.5-.38,1.15-.64,2-.58,1.69-1.38,4.14-2.32,7.2s-2,6.71-3,10.8-2.06,8.62-3,13.4-1.58,9.38-2.12,13.57-.89,8-1.12,11.16-.39,5.77-.46,7.55c-.05.85-.08,1.54-.11,2.06a3,3,0,0,1-.08.71,6.74,6.74,0,0,1,0-.72c0-.52,0-1.2,0-2.06,0-1.78.11-4.37.3-7.56s.52-7,1-11.2,1.19-8.8,2.09-13.6,2-9.34,3-13.43,2.15-7.75,3.15-10.79,1.83-5.49,2.48-7.16c.3-.8.55-1.44.73-1.92A3.29,3.29,0,0,1,415.86,186.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.84,201a3.13,3.13,0,0,1,.38.56l1,1.64c.88,1.43,2.09,3.55,3.52,6.2s3,5.86,4.69,9.48,3.31,7.67,4.88,12,2.85,8.51,3.92,12.35,1.87,7.33,2.45,10.28,1,5.35,1.25,7l.27,1.92a2.82,2.82,0,0,1,.06.67,3,3,0,0,1-.16-.65c-.1-.49-.22-1.12-.37-1.9-.29-1.66-.76-4.05-1.41-7s-1.49-6.41-2.55-10.23-2.4-8-3.95-12.3-3.22-8.35-4.83-12-3.18-6.84-4.57-9.5-2.55-4.81-3.38-6.27c-.39-.69-.7-1.26-.94-1.69A2.6,2.6,0,0,1,375.84,201Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.11,
    y: 250.2,
    width: 23.92,
    height: 2.25,
    rx: 1.09,
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.83,275.45c-.79-8.75-7.69-9.95-9-10.88a4,4,0,0,1-.76-.73,5.8,5.8,0,0,1-1.23-3.66v-8.85H392.51v8.85a5.79,5.79,0,0,1-1.22,3.66,3.8,3.8,0,0,1-.77.73c-1.32.93-8.22,2.13-9,10.88s-3.71,28.65,1.46,35c4.77,5.87,9.43,6.22,17.18,6.23h2.06c7.75,0,12.41-.36,17.18-6.23C424.55,304.1,421.63,284.21,420.83,275.45Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.48,252.52c0,.14-5.11.26-11.41.26s-11.41-.12-11.41-.26,5.11-.26,11.41-.26S412.48,252.37,412.48,252.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.36,180.07a6.14,6.14,0,0,0-5-3.54,12.51,12.51,0,0,0-6.24,1.08,9.49,9.49,0,0,0-4.51,3.21,7.09,7.09,0,0,0-.44,6.42,12.81,12.81,0,0,0,4.11,5.18c2.54-.43,5.11-2,7.31-3.31a11.91,11.91,0,0,0,4.06-3.73A6.12,6.12,0,0,0,426.36,180.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.51,223.54a4.86,4.86,0,0,1,0-4.8,9.86,9.86,0,0,1,3.5-3.53,7.42,7.42,0,0,1,4.11-1.45,5.56,5.56,0,0,1,4.33,2.6,10.13,10.13,0,0,1,1.48,5,17.57,17.57,0,0,1-5.43,3.21,9.41,9.41,0,0,1-4.22.93A4.8,4.8,0,0,1,370.51,223.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,212.69a4.79,4.79,0,0,1,0-4.79,9.71,9.71,0,0,1,3.5-3.53,7.33,7.33,0,0,1,4.1-1.46,5.58,5.58,0,0,1,4.34,2.61,10.08,10.08,0,0,1,1.47,5,17.52,17.52,0,0,1-5.42,3.21,9.16,9.16,0,0,1-4.23.93A4.75,4.75,0,0,1,394,212.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.11,211a4.9,4.9,0,0,0,.67-4.81,9.9,9.9,0,0,0-3-4,7.58,7.58,0,0,0-3.93-2,5.68,5.68,0,0,0-4.71,2A10.32,10.32,0,0,0,412,207a17.78,17.78,0,0,0,5,4,9.43,9.43,0,0,0,4.13,1.5A4.82,4.82,0,0,0,425.11,211Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.65,198.78a4.5,4.5,0,0,0-2.93-3.7,5.8,5.8,0,0,0-4.14.68,7,7,0,0,0-3.21,2.85,9.87,9.87,0,0,0-.83,6.19,13,13,0,0,0,2.23,5.24c1.69-.27,3.49-1.62,5-2.79a10.08,10.08,0,0,0,2.95-3.37A8.37,8.37,0,0,0,392.65,198.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.11,186.39a5.12,5.12,0,0,0-4.87,2.08,8.18,8.18,0,0,0-1.16,4.94,7.76,7.76,0,0,0,1.34,4.62,8.61,8.61,0,0,0,5.61,3.05,12.59,12.59,0,0,0,6.05-.76c.48-2,0-4.51-.48-6.66a10.68,10.68,0,0,0-2-4.51A7.35,7.35,0,0,0,403.11,186.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.33,201.81a16.86,16.86,0,0,1-.14,2.58,54.42,54.42,0,0,0-.1,6.2,41.58,41.58,0,0,0,.77,6.15,18,18,0,0,1,.5,2.53,9.38,9.38,0,0,1-.86-2.45,30.93,30.93,0,0,1-.93-6.2,36.71,36.71,0,0,1,.25-6.27A10.52,10.52,0,0,1,384.33,201.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.05,227.88a42.51,42.51,0,0,0-2.78-3.76,14.89,14.89,0,0,0-2.45-2.17c-.68-.48-1.18-.66-1.15-.74s.57,0,1.34.43a10.41,10.41,0,0,1,2.65,2.13A8.77,8.77,0,0,1,389.05,227.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,210a7.72,7.72,0,0,1,.84,3.57,7.57,7.57,0,0,1-.44,3.64c-.15,0,0-1.64-.08-3.61S406.81,210,407,210Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.1,205.33a34.58,34.58,0,0,1-4.82,6.92,16.61,16.61,0,0,1,2.2-3.61A17.32,17.32,0,0,1,413.1,205.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.86,205a9.1,9.1,0,0,1-.11-3.12,9.62,9.62,0,0,1,.41-3.1,18.73,18.73,0,0,1-.3,6.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.31,290.87a16.76,16.76,0,0,1-.34-3.28,79.61,79.61,0,0,1,0-8c.09-1.55.16-3,.35-4.39a8.67,8.67,0,0,1,1.18-3.44,5.08,5.08,0,0,1,1.75-1.72,1.67,1.67,0,0,1,.84-.31,6,6,0,0,0-2.28,2.22,8.78,8.78,0,0,0-1,3.32c-.17,1.31-.22,2.8-.3,4.35-.15,3.09-.15,5.9-.13,7.93A26.3,26.3,0,0,1,383.31,290.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.72,445.9a3.11,3.11,0,0,1-.89-.14,3,3,0,0,1-2.15-2.88V407.69h.78v35.19a2.23,2.23,0,0,0,4.1,1.21l23.89-36.61.66.43-23.9,36.61A2.94,2.94,0,0,1,352.72,445.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.61,445.9a3,3,0,0,1-2.49-1.38l-23.89-36.61.65-.43,23.9,36.61a2.22,2.22,0,0,0,4.09-1.21V407.69h.79v35.19a3,3,0,0,1-2.16,2.88A3.11,3.11,0,0,1,447.61,445.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.23,
    y: 316.06,
    width: 122.69,
    height: 95.29,
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.15,359.06s0-.21,0-.61,0-1,0-1.78c0-1.57,0-3.87,0-6.85,0-6,0-14.62-.06-25.49l.11.14-79.12.07h0l.16-.21c0,12.07,0,23.78,0,34.73l-.15-.2,56.61.09,16.53.06,4.44,0,1.15,0h-1.11l-4.41,0-16.5.05-56.71.1h-.15v-.2c0-10.95,0-22.66,0-34.73v-.2H350l79.12.07h.1v.13c0,10.9,0,19.59-.06,25.57,0,3,0,5.26,0,6.82,0,.76,0,1.35,0,1.75S429.15,359.06,429.15,359.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.15,400.24s0-.21,0-.61,0-1,0-1.78c0-1.57,0-3.87,0-6.85,0-6,0-14.62-.06-25.49l.11.14-79.12.07h0l.16-.21c0,12.07,0,23.78,0,34.73L350,400l56.61.09,16.53.06,4.44,0h1.17l-1.13,0-4.41,0-16.5.06-56.71.09h-.15v-.2c0-10.95,0-22.66,0-34.73v-.2H350l79.12.07h.1v.13c0,10.9,0,19.6-.06,25.58,0,3,0,5.25,0,6.81,0,.77,0,1.35,0,1.76S429.15,400.24,429.15,400.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.37 324.13 375.94 327.71 405.4 327.71 408.33 324.13 373.37 324.13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.48 365.31 376.05 368.89 405.51 368.89 408.44 365.31 373.48 365.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.66,
    y: 316.06,
    width: 28.27,
    height: 95.29,
    style: {
      fill: "#6f4439"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-59"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 191.19,
    cy: 148.67,
    r: 28.8,
    transform: "translate(13.57 313.32) rotate(-80.7)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,148.67a2.9,2.9,0,0,1-.06-.46c0-.34-.05-.79-.09-1.37,0-.3,0-.64-.07-1s-.12-.76-.19-1.2a21.57,21.57,0,0,0-.6-3,27.73,27.73,0,0,0-3.2-7.62,28.56,28.56,0,0,0-34.32-12.18,29,29,0,0,0-3.72,1.64,29.59,29.59,0,0,0-3.5,2.24,32.28,32.28,0,0,0-3.23,2.76,33,33,0,0,0-2.8,3.3,27.68,27.68,0,0,0-4.07,7.86,28.29,28.29,0,0,0,0,18,27.43,27.43,0,0,0,4.07,7.86,34.23,34.23,0,0,0,2.8,3.31,32.17,32.17,0,0,0,3.23,2.75,29.68,29.68,0,0,0,3.5,2.25,30.5,30.5,0,0,0,3.72,1.64,28.75,28.75,0,0,0,15,1.25,28.79,28.79,0,0,0,19.32-13.43,27.55,27.55,0,0,0,3.2-7.62,21.69,21.69,0,0,0,.6-3c.07-.43.15-.83.19-1.2s.05-.7.07-1c0-.58.07-1,.09-1.36a2.93,2.93,0,0,1,.06-.47s0,.16,0,.47,0,.79,0,1.37l0,1c0,.37-.1.78-.16,1.21a20.05,20.05,0,0,1-.56,3,26.94,26.94,0,0,1-3.14,7.73,29,29,0,0,1-19.51,13.74A29.2,29.2,0,0,1,181.29,176a31.57,31.57,0,0,1-3.79-1.66,29.92,29.92,0,0,1-3.57-2.28,26.79,26.79,0,0,1-6.16-6.17,28,28,0,0,1-4.16-8,28.84,28.84,0,0,1,0-18.36,28.24,28.24,0,0,1,4.16-8,33.11,33.11,0,0,1,2.86-3.36,32.16,32.16,0,0,1,3.3-2.8A30,30,0,0,1,177.5,123a31.57,31.57,0,0,1,3.79-1.66,29.09,29.09,0,0,1,15.26-1.22,29,29,0,0,1,19.51,13.73,27.16,27.16,0,0,1,3.14,7.73,20.05,20.05,0,0,1,.56,3c.06.44.13.84.16,1.21l0,1c0,.58,0,1,0,1.38S220,148.67,220,148.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182.67,
    cy: 147.95,
    r: 3.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.71,
    cy: 147.95,
    r: 3.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.13,148a3.39,3.39,0,1,1-3.39-3.38A3.39,3.39,0,0,1,204.13,148Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.37,154.93a4,4,0,1,1-4-4A4,4,0,0,1,233.37,154.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.37,154.93c-.05,0-.06-.36-.23-1a4.13,4.13,0,0,0-1.48-2.08,3.84,3.84,0,0,0-3.6-.49,3.76,3.76,0,0,0,0,7.06,3.84,3.84,0,0,0,3.6-.49,4.11,4.11,0,0,0,1.48-2.09c.17-.59.18-.95.23-.95a1.94,1.94,0,0,1,0,1,4,4,0,0,1-1.45,2.35,4.2,4.2,0,0,1-4,.67,4.27,4.27,0,0,1,0-8.06,4.2,4.2,0,0,1,4,.67,4,4,0,0,1,1.45,2.35A1.94,1.94,0,0,1,233.37,154.93Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-59"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "308.99 356.74 335.18 445.9 327.82 445.9 291.71 356.12 308.99 356.74",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.73 356.74 270.92 445.05 263.56 445.05 227.45 356.12 244.73 356.74",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.95 356.74 141.21 445.05 148.57 445.05 182.24 356.12 164.95 356.74",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.84 356.74 219.34 445.05 226.7 445.05 259.13 356.12 241.84 356.74",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.76,318.08s-2-26.88,2.05-34.56,43.45-23.24,43.45-23.24,27-42.64,45.07-51.66,88.57-7.78,98.82,6.15-1.23,50.42-6.56,72.56l-19.27,54.11L309,356.74H162.24Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.55,214.34a2.73,2.73,0,0,1,.11.28c.06.18.16.46.26.83.22.75.51,1.86.8,3.31a51.38,51.38,0,0,1,.91,12.52,85.85,85.85,0,0,1-1,8.7c-.48,3.12-1.05,6.45-1.69,10-1.27,7-2.78,14.76-4.48,22.95l0,.13-.11.05c-2.2,1.11-4.52,2.28-6.9,3.43a423.72,423.72,0,0,1-43.72,18.37c-5.72,2-10.39,3.55-13.63,4.56l-3.74,1.14-1,.28-.34.08.32-.13,1-.33,3.71-1.23c3.22-1.08,7.87-2.64,13.57-4.72A453.52,453.52,0,0,0,321.19,276c2.38-1.15,4.7-2.33,6.9-3.43l-.14.18c1.71-8.19,3.24-15.93,4.54-22.94.65-3.5,1.24-6.82,1.73-9.93s.92-6,1.07-8.65a53.72,53.72,0,0,0-.75-12.48c-.26-1.45-.52-2.56-.71-3.31-.09-.35-.16-.63-.22-.85A1.09,1.09,0,0,1,333.55,214.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.7,340.05a69.56,69.56,0,0,1,1.65,8.3,69.89,69.89,0,0,1,1.14,8.39,69,69,0,0,1-1.65-8.3A69.89,69.89,0,0,1,169.7,340.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.67,356.12c-.14,0,1.5-10.3,3.66-22.94s4-22.87,4.17-22.85-1.49,10.29-3.65,22.94S245.82,356.14,245.67,356.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.91,363.47,48.74,389S16,377.07,11.83,381.43l48.09,40.89L93,383.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.38,399.56a2.58,2.58,0,0,1-.54,3.4,2.49,2.49,0,0,1-3.38-.52,2.72,2.72,0,0,1,.6-3.59c1.1-.64,3-.25,3.45.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.92,422.32l3.18-4L15.8,380.6s-2.93-.89-4,.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.17,388.09c-.19.25.89,1.35,1.4,3.09s.29,3.25.59,3.34,1.1-1.57.44-3.66S48.3,387.84,48.17,388.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.35,385.89c-.25.18.43,1.45.38,3.12s-.71,2.92-.46,3.11,1.52-1,1.54-3.1S41.55,385.67,41.35,385.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.35,389.49c.17.23,1.5-.66,2-2.46s-.17-3.24-.44-3.13-.17,1.37-.6,2.84S33.14,389.27,33.35,389.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.41,382.79c-.08.29,1.27.89,2.52,2.1s1.93,2.52,2.22,2.42,0-1.78-1.48-3.19S53.45,382.5,53.41,382.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.75,320.09c0,2.32-10.34,108.63-10.34,108.63l34.93,4s8.69-53.62,10-63.5,5.87-27.59,5.87-27.59l74.51-7.37s-36.55-51.12-40.1-51.34S112.75,320.09,112.75,320.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.39,378.84s62.53-84.78,66.14-89.22,7.77-9.15,20.81-9.15,48.32,2.5,48.32,2.5l18.64-8.49L274,284.91s2.5,32.19-1.94,39.69-30.8,9.43-36.35,9.71-91.51-11.39-91.51-11.39h0s-16.84,23.38-24.93,32.36c-5.76,6.41-36.53,45.9-36.53,45.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.79,401.87l-31.1-22.93.29-.4c.63-.85,62.59-84.83,66.16-89.23,3.38-4.16,7.59-9.34,21.2-9.34,12.52,0,45.89,2.33,48.23,2.49l18.66-8.5.15,0,68.05,10.49,0,.39c.1,1.33,2.46,32.44-2,40-4.82,8.13-33.5,9.79-36.76,10-5.41.31-84.87-10.49-91.3-11.36-1.82,2.52-17.22,23.76-24.79,32.17-5.68,6.32-36.2,45.47-36.51,45.86ZM53.08,378.73,82.6,400.49c3.2-4.11,30.85-39.53,36.26-45.54,8-8.87,24.73-32.09,24.9-32.33l.17-.24.3,0c.86.12,86,11.66,91.41,11.39,1.28-.07,31.32-1.65,35.95-9.47,4.05-6.83,2.17-35.29,1.9-39L206.37,275l-18.62,8.48h-.13c-.35,0-35.4-2.5-48.28-2.5-13.13,0-17.17,5-20.42,9C115.49,294.16,57.77,372.38,53.08,378.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.25,311.68a48.12,48.12,0,0,1,4,5.77,47.3,47.3,0,0,1,3.6,6.05,47.14,47.14,0,0,1-4-5.77A47.3,47.3,0,0,1,137.25,311.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.23,407.7,107,440.19S74.59,452.91,74.34,459l63.11-1.19-.7-50.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.48,437.09a2.58,2.58,0,0,1,1.84,2.91,2.48,2.48,0,0,1-2.87,1.84,2.72,2.72,0,0,1-1.93-3.09c.4-1.2,2.07-2.16,3.2-1.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.45,457.76l-.27-5.11L76.77,455.7S74,457,74.34,459Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,439.89c0,.31,1.56.42,3.09,1.38s2.37,2.24,2.65,2.12-.21-1.9-2.09-3S105.91,439.61,106,439.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.42,442.75c-.07.3,1.28.8,2.35,2.08s1.4,2.66,1.7,2.64.47-1.76-.89-3.34S99.42,442.46,99.42,442.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.81,450.75c.28.06.68-1.49-.15-3.16s-2.27-2.32-2.4-2.06.79,1.14,1.44,2.53S95.5,450.72,95.81,450.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4,432.44c.14.28,1.54-.17,3.29-.09s3.11.61,3.26.34-1.17-1.34-3.22-1.41S106.25,432.2,106.4,432.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.78,201.16,235,221.43l-25.45,51.05s-15.05,5-20.38,10.49l12.19.53a84.51,84.51,0,0,1,48.38,17.74c6,4.7,10.87,9.78,11.77,14.4,2.65,13.6,6.71,11.5,6.71,11.5l15.43-19.85,10.8-21.48,21.69-84.14-20.93-11.5-4.7-6.84-31,4.32-6.17,6.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.37,255.54l13-5.44,20.43-28.66s9.48-18.95,18-20.28S235,221.43,235,221.43l-13.1,37.2-21.13,14.79-14.57-1.27-9.43-8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.81,208.21a3.8,3.8,0,0,1-.23.67c-.18.48-.43,1.1-.73,1.87-.66,1.69-1.59,4-2.72,6.88-2.29,5.82-5.36,13.89-8.72,22.81s-6.49,17-8.87,22.76c-1.18,2.89-2.17,5.22-2.88,6.82l-.82,1.83a3,3,0,0,1-.32.63,3.19,3.19,0,0,1,.22-.67c.19-.47.43-1.1.74-1.87.66-1.68,1.59-4,2.72-6.88,2.29-5.81,5.36-13.88,8.72-22.81s6.48-17,8.86-22.75c1.19-2.89,2.18-5.23,2.89-6.82l.82-1.84A3.33,3.33,0,0,1,234.81,208.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.32,207.37a8.61,8.61,0,0,1-.78-1.38c-.51-1-1.16-2.28-2-3.84h.34c-.68,1.5-1.47,3.28-2.53,5.17a22.38,22.38,0,0,1-4.24,5.6l-.49.45.05-.66v-.11c.38-5.16,1-9.81,1.53-13.15.28-1.67.53-3,.72-3.95a8.14,8.14,0,0,1,.35-1.43,7.41,7.41,0,0,1-.15,1.46c-.14,1-.33,2.37-.55,4-.46,3.35-1,8-1.38,13.14v.11l-.43-.21a23.15,23.15,0,0,0,4.17-5.45c1.06-1.86,1.89-3.62,2.61-5.1l.18-.37.16.37c.73,1.58,1.33,2.9,1.8,3.91A9.33,9.33,0,0,1,260.32,207.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.17,191.75a1.72,1.72,0,0,1-.29.41l-.9,1.1c-.8,1-2,2.3-3.48,3.93a158.2,158.2,0,0,1-12.4,12c-2.32,2-4.59,3.88-6.71,5.53l-.38.3v-.48a34.12,34.12,0,0,0-1.56-9.57l.25.09-3.8,2.18a10.8,10.8,0,0,1-1.4.73,9.31,9.31,0,0,1,1.3-.89l3.73-2.31.17-.11.07.2a32.34,32.34,0,0,1,1.72,9.67l-.39-.19c2.1-1.66,4.36-3.53,6.66-5.54,5.09-4.42,9.43-8.72,12.49-11.9,1.53-1.59,2.74-2.91,3.59-3.81l1-1A2.32,2.32,0,0,1,293.17,191.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.29,186l2.11-43c1.34-13.46-5.38-25.47-18.88-26.43l-1.25,0a24.2,24.2,0,0,0-24.41,21.93c-1.09,11.68-2.15,24.59-2.16,30.87,0,13,12.95,15.17,12.95,15.17s-.34,7.89-.56,11.69h0l2.72,9.9Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.68,184.53a31.36,31.36,0,0,0,17-4.77s-4.2,9.7-17.14,8.37Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.73,150.33a1.85,1.85,0,0,0,1.77,1.89,1.78,1.78,0,0,0,1.93-1.65,1.84,1.84,0,0,0-1.76-1.89A1.78,1.78,0,0,0,252.73,150.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.57,143.78c.23.25,1.65-.77,3.64-.74s3.45,1.05,3.67.81-.12-.55-.76-1a5.06,5.06,0,0,0-2.93-1,4.89,4.89,0,0,0-2.9.9C251.67,143.24,251.46,143.67,251.57,143.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.13,150.71a1.86,1.86,0,0,0,1.77,1.89,1.77,1.77,0,0,0,1.93-1.64,1.86,1.86,0,0,0-1.76-1.9A1.78,1.78,0,0,0,270.13,150.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.12,144.5c.23.25,1.65-.77,3.64-.74s3.45,1,3.67.8-.12-.54-.75-1a5.12,5.12,0,0,0-2.93-.94,4.85,4.85,0,0,0-2.9.89C271.23,144,271,144.39,271.12,144.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.77,159.74a13.79,13.79,0,0,0-3.24-.63c-.5-.06-1-.16-1.07-.51a2.69,2.69,0,0,1,.36-1.51c.5-1.23,1-2.51,1.56-3.86,2.16-5.5,3.74-10,3.52-10.1s-2.16,4.3-4.32,9.79c-.53,1.36-1,2.65-1.5,3.89a2.93,2.93,0,0,0-.29,2,1.25,1.25,0,0,0,.83.76,3.67,3.67,0,0,0,.86.13A13,13,0,0,0,263.77,159.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.56,138.25c.26.51,2.21,0,4.56,0s4.32.38,4.57-.15c.1-.25-.29-.71-1.11-1.13a7.45,7.45,0,0,0-3.49-.74,7.57,7.57,0,0,0-3.47.87C270.82,137.53,270.44,138,270.56,138.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.56,137.92c.4.46,2,0,4,.07s3.6.4,4-.06c.17-.22-.07-.69-.78-1.13a6.66,6.66,0,0,0-6.44,0C251.62,137.23,251.38,137.69,251.56,137.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.24,152.14c.22-.1,8.95-2.53,8.55,6.35s-9.22,6.64-9.22,6.38S292.24,152.14,292.24,152.14Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.43,161.63s.15.12.4.25A1.56,1.56,0,0,0,296,162c.95-.31,1.81-1.76,1.92-3.36a5.06,5.06,0,0,0-.33-2.23,1.8,1.8,0,0,0-1.11-1.24.78.78,0,0,0-.93.39c-.13.24-.08.42-.13.43s-.19-.16-.1-.52a1,1,0,0,1,.38-.54,1.17,1.17,0,0,1,.86-.19,2.18,2.18,0,0,1,1.55,1.45,5.34,5.34,0,0,1,.43,2.5c-.14,1.78-1.13,3.42-2.43,3.73a1.67,1.67,0,0,1-1.4-.3C294.43,161.85,294.4,161.65,294.43,161.63Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.62,125.38a2.13,2.13,0,0,1,1-1.19,6.43,6.43,0,0,1,3.34-.4,18.58,18.58,0,0,0,8.21-1.69,9.1,9.1,0,0,1-2.31-1.77,5.57,5.57,0,0,1-1.37-5.61,1.25,1.25,0,0,1,.73-.82c.59-.15,1.07.44,1.45.9a4.8,4.8,0,0,0,4.43,2.11,7.86,7.86,0,0,0,3.42-.86,1.31,1.31,0,0,0,.11-.12l1.42-1.31h0c3.48-3.17,6.45-5.34,9.46-6.4,4.4-1.56,11.68-2,16.15-.58s8.36,5.22,8.79,9.88c2.62-2,6.43-1.85,9.46-.48l.08,0c3.38,1.37,5.18,5.08,6,8.63.05.2.09.39.13.59a13.69,13.69,0,0,0,4.43,4.71c.33.21.7.46.72.85s-.31.68-.63.89a6.81,6.81,0,0,1-2.83,1,15.22,15.22,0,0,0,1,2.47c.36.67.78,1.48.42,2.14a1.46,1.46,0,0,1-1.55.6,4.39,4.39,0,0,1-1.57-.79c.35.93.69,1.87,1,2.8a8.12,8.12,0,0,1-3.72-.41c-.87,3.24-1.68,9.29-2.62,11.47-2.36-.06-2.92-.34-4.13,0-1.55.44-1.09,3.19-3.05,2.33-1-.44-2.4-4.37-2.7-5.42a50.87,50.87,0,0,1-1.27-21.54,16.21,16.21,0,0,0-4.87-3.84l.15.14c-3.58-1.41-7.63-2.83-11.14-1.27-2.73,1.2-4.42,3.91-6.51,6a18.57,18.57,0,0,1-14,6.08c-.68,3.9-1.11,10.3-1.46,13.94l-2.8-7.45v0c-.23-.44-.42-.88-.6-1.32l-.07-.13v0c-.29-.71-.57-1.42-.94-2.12l0,0a2.29,2.29,0,0,1-3.21-3.2,5.09,5.09,0,0,1,1.16-1.06A3.61,3.61,0,0,1,238,134a2.85,2.85,0,0,1-1.89-2.89,2.41,2.41,0,0,1,1.52-1.87A8.27,8.27,0,0,1,233,128C232.12,127.41,231.26,126.51,231.62,125.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.34,118.83a12.66,12.66,0,0,1,1.25,1.25,9.25,9.25,0,0,1,1.81,4.4,16.63,16.63,0,0,1,.19,3.31c0,1.2-.2,2.47-.35,3.82a36,36,0,0,0-.28,4.25,14.48,14.48,0,0,0,.2,2.26,4.67,4.67,0,0,0,.82,2.22,2,2,0,0,0,1.81.7,3,3,0,0,0,1.69-.86,6.78,6.78,0,0,0,1.39-3.25l-.27,0a10.58,10.58,0,0,0,1.46,2.79,3.86,3.86,0,0,0,2.47,1.48,2.43,2.43,0,0,0,1.34-.18,2.13,2.13,0,0,0,.95-.85,2.27,2.27,0,0,0,.33-1.14,1.61,1.61,0,0,0-.38-1l-.14.12a8.34,8.34,0,0,0,2.7,2.21,6.06,6.06,0,0,0,.85.37,1.13,1.13,0,0,0,.31.09l-.29-.13c-.19-.09-.47-.22-.82-.42a8.41,8.41,0,0,1-2.6-2.24l-.15.12a1.66,1.66,0,0,1,0,1.93,1.93,1.93,0,0,1-.86.76,2.27,2.27,0,0,1-1.22.15,3.64,3.64,0,0,1-2.29-1.41,10.82,10.82,0,0,1-1.41-2.73l-.17-.42-.1.44a6.61,6.61,0,0,1-1.33,3.11,2.68,2.68,0,0,1-1.51.77,1.68,1.68,0,0,1-1.54-.59,4.39,4.39,0,0,1-.75-2.08,13.86,13.86,0,0,1-.2-2.21,33.79,33.79,0,0,1,.26-4.22c.14-1.35.28-2.63.32-3.84a16.28,16.28,0,0,0-.23-3.36,9.07,9.07,0,0,0-1.93-4.43A5.19,5.19,0,0,0,282.34,118.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.62,129.74l.1.1c.09.06.19.15.32.25a3.93,3.93,0,0,0,.53.37,6.55,6.55,0,0,0,.77.45,11.51,11.51,0,0,0,5.52,1.24,14.64,14.64,0,0,0,8-2.56,25.4,25.4,0,0,0,7.07-7.47c1-1.53,1.85-3.11,2.76-4.56a17.56,17.56,0,0,1,3.07-3.83,8.94,8.94,0,0,1,3.84-2.11,6.45,6.45,0,0,1,2-.14,6.79,6.79,0,0,1,1.79.42,7.61,7.61,0,0,1,2.64,1.75,7.46,7.46,0,0,1,1.38,2,9.3,9.3,0,0,1,.59,2s0,0,0-.14,0-.24,0-.4a6.85,6.85,0,0,0-.43-1.49,7.55,7.55,0,0,0-1.37-2,7.64,7.64,0,0,0-2.68-1.83,7.27,7.27,0,0,0-1.85-.46,6.88,6.88,0,0,0-2.06.13,9.18,9.18,0,0,0-4,2.15,17.49,17.49,0,0,0-3.14,3.88c-.92,1.46-1.76,3-2.77,4.56a25.57,25.57,0,0,1-7,7.4,14.61,14.61,0,0,1-7.81,2.58,11.82,11.82,0,0,1-5.46-1.13A19.29,19.29,0,0,1,241.62,129.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.69,124a2,2,0,0,0,.45.34,9.67,9.67,0,0,0,1.35.76,13,13,0,0,0,2.15.81,14.15,14.15,0,0,0,5.59.42,12.74,12.74,0,0,0,2.25-.48,9.6,9.6,0,0,0,1.45-.55,2.16,2.16,0,0,0,.5-.27s-.76.28-2,.61a15.37,15.37,0,0,1-5,.46,16.69,16.69,0,0,1-2.73-.46,13.77,13.77,0,0,1-2.13-.74C241.39,124.38,240.72,123.94,240.69,124Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.62,165.81c.12-.32,2.17.61,4.42-.49s3-3.38,3.3-3.26.18.66-.21,1.59a5.62,5.62,0,0,1-2.64,2.78,4.87,4.87,0,0,1-3.65.28C264,166.4,263.55,165.94,263.62,165.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.67,356.12c0-.63,7-45.79,9.64-51.55,2.13-4.56,19.19-8.12,37.47-15.5,19.68-7.94,42.49-8.49,42.49-8.49l-28.88,66.66Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.9 260.35 239.23 261.59 239.23 277.53 258.07 279.78 255.9 260.35",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.75,197.88c8.23,3.38,15.86,10.68,15.36,20.14-.74,14-4,44.11-4.79,51.86-1,10.12-4.42,18.64-19.31,19.2s-36.8-3.06-36.8-3.06-7.89,4-10.07-.39c-.57-1.17-4.49-24.74-4.49-24.74,0-.32,1.93-2.56,4.69-3.94a6.6,6.6,0,0,1,8.67,2.67h0l29-.95,5.75-27.3",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.79,231.37a4.14,4.14,0,0,1-.07.47c-.07.33-.16.79-.27,1.39-.25,1.23-.62,3-1.09,5.36-1,4.7-2.38,11.53-4.16,20.12l0,.12h-.13l-20.4.7-5.83.2-1.5.05-.75,0H262s-.37-.21-.2-.12h0l-.1-.15a6.2,6.2,0,0,0-2.07-2.1,6.32,6.32,0,0,0-5.87-.45,12.58,12.58,0,0,0-2.71,1.68,13.73,13.73,0,0,0-1.22,1.07c-.19.19-.38.39-.55.59s-.17.21-.25.31-.16.28-.15.23v0c.92,5.48,1.9,11.24,3,17.2.28,1.49.56,3,.84,4.51.15.75.3,1.51.48,2.26a2.31,2.31,0,0,0,.39,1,3.47,3.47,0,0,0,.31.44l.4.37a5.58,5.58,0,0,0,4.34.64,17.14,17.14,0,0,0,4.47-1.48l.08,0h.08c5.9.93,12.13,1.72,18.49,2.32,4.39.4,8.75.69,13.05.77s8.56,0,12.52-1.19a16.51,16.51,0,0,0,5.37-2.81,13.92,13.92,0,0,0,3.73-4.6A30.9,30.9,0,0,0,319.17,269c1.59-15.24,3-29,4-40.51.25-2.88.46-5.63.63-8.23.09-1.31.17-2.57.15-3.78,0-.61-.12-1.21-.17-1.79s-.23-1.15-.35-1.71a17.77,17.77,0,0,0-2.7-5.73,24.88,24.88,0,0,0-3.55-4,30.63,30.63,0,0,0-6.11-4.22c-.75-.41-1.34-.67-1.74-.85l-.59-.29s.21.07.61.24,1,.42,1.77.81a29.94,29.94,0,0,1,6.2,4.15,25.83,25.83,0,0,1,3.62,4,18.16,18.16,0,0,1,2.77,5.8c.12.57.26,1.14.37,1.73s.15,1.2.18,1.82c0,1.25,0,2.52-.13,3.82-.16,2.6-.36,5.36-.59,8.24-.94,11.56-2.34,25.29-3.9,40.53a31.3,31.3,0,0,1-2.8,11.45,14.62,14.62,0,0,1-3.85,4.77,17.27,17.27,0,0,1-5.54,2.9c-4,1.24-8.39,1.27-12.68,1.22s-8.69-.37-13.09-.77c-6.37-.6-12.6-1.39-18.52-2.33l.16,0a18.3,18.3,0,0,1-4.62,1.53A6.08,6.08,0,0,1,254,287l-.46-.43a3.11,3.11,0,0,1-.36-.51,2.91,2.91,0,0,1-.45-1.15c-.19-.77-.33-1.53-.48-2.29-.28-1.51-.56-3-.84-4.51-1.07-6-2-11.73-3-17.21v0h0a1.14,1.14,0,0,1,.24-.51c.09-.11.18-.23.27-.33s.38-.42.58-.62a13.17,13.17,0,0,1,1.26-1.11,13.6,13.6,0,0,1,2.82-1.73,6.82,6.82,0,0,1,8.49,2.74l.11.17h0c.17.1-.24-.13-.19-.1h.54l.76,0,1.5-.05,5.83-.18,20.4-.63-.16.13c1.84-8.57,3.3-15.39,4.31-20.08l1.17-5.35c.14-.6.24-1.05.31-1.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,200.16c.06.07-1,1.1-2.5,3a36.45,36.45,0,0,0-4.67,8.11,40.7,40.7,0,0,0-2.56,9c-.4,2.37-.48,3.87-.58,3.86a4.49,4.49,0,0,1,0-1.05c0-.68.09-1.66.23-2.87a36.09,36.09,0,0,1,2.45-9.16,34.9,34.9,0,0,1,2.38-4.66,31.5,31.5,0,0,1,2.48-3.48,24.63,24.63,0,0,1,2-2.1C306.68,200.37,307,200.13,307,200.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.55,270.88c-.09,0-.31-1-1-2.51a16.56,16.56,0,0,0-9.11-8.65c-1.55-.59-2.58-.76-2.56-.85s.26,0,.73,0a10.4,10.4,0,0,1,1.95.46,13.86,13.86,0,0,1,2.72,1.22,16.58,16.58,0,0,1,2.93,2.18,16.84,16.84,0,0,1,2.33,2.81,14.14,14.14,0,0,1,1.35,2.65,10,10,0,0,1,.56,1.92C303.56,270.62,303.59,270.87,303.55,270.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.44,285.19c-.08,0,.32-1.43.65-3.77a56.9,56.9,0,0,0,.51-9.17,47.5,47.5,0,0,0-.4-5,30.88,30.88,0,0,0-.85-4c-.65-2.26-1.43-3.51-1.34-3.56a4.05,4.05,0,0,1,.57.86,7.37,7.37,0,0,1,.54,1.09,11,11,0,0,1,.58,1.5,26,26,0,0,1,1,4.07,41.18,41.18,0,0,1,.45,5.1,45.59,45.59,0,0,1-.67,9.24,25,25,0,0,1-.64,2.74A4.35,4.35,0,0,1,263.44,285.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.25,225.07s1.13-2.71,3.38-3.27c0,0,11.16,3,14.42,6.56,0,0,.65-2.54,6.64-7.64a26.81,26.81,0,0,1,15.87-6.38l5.93,3.73-23.77,16.65-7.07,2.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.25,225.07a2,2,0,0,1,.3.2l.83.63,3.12,2.39L165.77,237l-.19,0,7.06-2.49,0,0L196.07,218l.27-.19v.44c-2-1.27-4-2.52-5.93-3.73l.14,0a26.64,26.64,0,0,0-13.68,4.75,39.13,39.13,0,0,0-5,4.31,26.12,26.12,0,0,0-2.08,2.31,10,10,0,0,0-1.51,2.44l-.12.32-.23-.23a14.66,14.66,0,0,0-4-2.72,40.58,40.58,0,0,0-4-1.74c-2.5-1-4.66-1.64-6.38-2.14h.05A5.09,5.09,0,0,0,150.9,224a9,9,0,0,0-.49.79c-.11.18-.15.27-.16.27a.91.91,0,0,1,.11-.3,7.68,7.68,0,0,1,.45-.82,5.12,5.12,0,0,1,2.79-2.25h.06c1.73.46,3.91,1.11,6.43,2.05a41.5,41.5,0,0,1,4,1.7,15.49,15.49,0,0,1,4.11,2.77l-.35.09a9.91,9.91,0,0,1,1.57-2.61,26.67,26.67,0,0,1,2.09-2.35A40.12,40.12,0,0,1,176.6,219a27,27,0,0,1,14-4.88h.07l.07,0,5.93,3.72.33.21-.32.23-.27.19L172.84,234.9l0,0h0l-7.08,2.44-.1,0-.09-.07-11.22-9-3-2.45-.78-.64A1.4,1.4,0,0,1,150.25,225.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.33,224.61l.67-1.35,16.74,9.32s5.5-.34,5.61-4c0,0,27.41-11.46,28.08-11.12S242,254.26,242,254.26l-39.65,8.45L184,254.59Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.3,260.48c-.09.11-7.68-6.05-17-13.75s-16.7-14-16.61-14.15,7.68,6,16.95,13.75S197.39,260.36,197.3,260.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,261.33c-.1.11-8.74-7.1-19.3-16.1s-19-16.39-19-16.5,8.73,7.1,19.3,16.11S208.05,261.22,208,261.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.58,240.06c-.11,0-3.85-.36-4.74,1.27s-1,2.52-.64,3.49a17.17,17.17,0,0,0,2.16,3L167,249a7.11,7.11,0,0,0-.6,4.42,6.57,6.57,0,0,0,2.42,3.19s.3,4.87,3.26,4.91a3.69,3.69,0,0,0,3.48,2.69c2.72-.07,4.09.63,7.11-.93s6.52-3.12,7.29-4.68-1.92-1.73-1.92-1.73,1.46-4-3.25-3.48c0,0,.53-4.15-2.49-4.65a57.54,57.54,0,0,0-9.16-.13l-2.42-2.92s1.76-.5,1.86-2.06S171,240.11,169.58,240.06Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.19,255.91c-.3.1-3.93,1.72-6.35,1.41s-21.18-10.58-23.9-11.39-7.36,0-4,3.53,13.62,9.28,13.82,9.58a13.53,13.53,0,0,1,.61,1.95l-10.49-4s-7.67-3.83-8.88-1.51.61,3.63,2.52,4.23,4,1.25,4,1.25,2.22,4.1,4.43,5.71,12.31,8.07,14,8.78,22.39,2.32,22.79,2,0-15.43,0-15.43l-7.26-6.55Z",
    style: {
      fill: "#ffbf9d"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManreadingPana);
export default __webpack_public_path__ + "static/media/Man reading-pana.4c5b1d2cbd24f9bcf963ff8c6a4cc7cd.svg";
export { ForwardRef as ReactComponent };